var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 6.667h5.333c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-1.333v17.333c0 2.209-1.791 4-4 4h-13.333c-2.209 0-4-1.791-4-4v-17.333h-1.333c-0.736 0-1.333-0.597-1.333-1.333s0.597-1.333 1.333-1.333h5.333v-1.333c0-2.209 1.791-4 4-4h5.333c2.209 0 4 1.791 4 4v1.333zM20 6.667v-1.333c0-0.736-0.597-1.333-1.333-1.333h-5.333c-0.736 0-1.333 0.597-1.333 1.333v1.333h8zM24 9.333h-16v17.333c0 0.736 0.597 1.333 1.333 1.333h13.333c0.736 0 1.333-0.597 1.333-1.333v-17.333z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.ad1bfd68.svg";
export { ForwardRef as ReactComponent };